<template>
  <div class="modal-mask" @click.self="close">
    <div class="modal">
      <div class="head">
        <h4>My Page</h4>
        <div class="head-btns">
          <button v-if="showRegister" class="primary" :disabled="busy" @click="doRegister">등록</button>
          <button v-if="showSave" class="primary" :disabled="busy" @click="doSave">수정</button>
          <button class="ghost" :disabled="busy" @click="reload">재조회</button>
          <button class="ghost" @click="close">취소</button>
        </div>
      </div>

      <!-- 20008/20009: 아이디 위 안내 문구(role/reg_yn 기반, 색상 적/청). A case 에서는 감춤 -->
      <p v-if="showNotice" class="reg-notice" :class="noticeClass">{{ regNotice }}</p>

      <div class="form">
        <div class="fr"><label>아이디</label><input :value="loginId" disabled /></div>
        <!-- 스펙25001: 이름(한글)은 staff/admin(C case)만 수정 가능·필수. 변경 시 저장. maxlength 100. -->
        <div class="fr"><label><i v-if="isStaffAdmin" class="rp red"></i>이름(한글)</label><input type="text" v-model="name" :disabled="!isStaffAdmin" maxlength="100" /></div>
        <!-- 20006: A case(customer 가 자식 정보 조회)에서는 민감정보 마스킹(type=password) -->
        <!-- 20007: 필수 설정 항목 text 왼쪽에 적색 point. 단, 비밀번호/비밀번호 확인은 청색 point -->
        <!-- 20009: 필수 설정 항목 point 는 role 별 필수 항목만 적색 표시(비밀번호류는 point 없음). 센터는 공통 적색, 나머지는 customer 만 적색 -->
        <!-- 20009: 필드 순서 - 비밀번호/비밀번호 확인 다음에 이름(영문) 배치 -->
        <div class="fr"><label>비밀번호</label><input type="password" v-model="password" :disabled="!fieldsEnabled" /></div>
        <div class="fr"><label>비밀번호 확인</label><input type="password" v-model="passwordConfirm" :disabled="!fieldsEnabled" /></div>
        <div class="fr"><label><i v-if="!isStaffAdmin" class="rp red"></i>이름(영문)</label><input :type="isACase ? 'password' : 'text'" v-model="enName" :disabled="!fieldsEnabled" maxlength="100" /></div>
        <div class="fr"><label><i v-if="!isStaffAdmin" class="rp red"></i>이메일</label><input :type="isACase ? 'password' : 'text'" v-model="email" :disabled="!fieldsEnabled" maxlength="100" /></div>
        <div class="fr">
          <label><i v-if="!isStaffAdmin" class="rp red"></i>주민번호</label>
          <input class="jumin" :type="isACase ? 'password' : 'text'" v-model="jumin1" :disabled="!fieldsEnabled" maxlength="6" />
          <span class="dash">-</span>
          <input class="jumin" :type="isACase ? 'password' : 'text'" v-model="jumin2" :disabled="!fieldsEnabled" maxlength="7" />
        </div>
        <div class="fr">
          <label><i v-if="!isStaffAdmin" class="rp red"></i>은행</label>
          <!-- A case: 은행명 마스킹(select 대신 password 표시) -->
          <input v-if="isACase" type="password" :value="bankName" disabled />
          <select v-else v-model="bankCode" :disabled="!fieldsEnabled">
            <option value="">선택</option>
            <option v-for="b in banks" :key="b.code" :value="b.code">{{ b.name }}</option>
          </select>
        </div>
        <!-- 22001: A case 마스킹 대상은 이름(영문)/이메일/주민번호/은행/휴대전화 2개 에디트. 계좌번호는 password 마스킹하지 않음. -->
        <div class="fr"><label><i v-if="!isStaffAdmin" class="rp red"></i>계좌번호</label><input type="text" v-model="account" :disabled="!fieldsEnabled" /></div>
        <!-- 22001: 휴대전화(콤보+에디트2, 3컬럼 저장). A case: 콤보 * 처리(dots), 2개 에디트 password. 콤보 보통 길이. -->
        <div class="fr">
          <label><i v-if="!isStaffAdmin" class="rp red"></i>휴대전화</label>
          <input v-if="isACase" type="password" :value="phonePrefix" disabled class="phcombo" />
          <select v-else class="phcombo" v-model="phonePrefix" :disabled="!fieldsEnabled">
            <option value="">선택</option>
            <option v-for="p in phonePrefixes" :key="p" :value="p">{{ p }}</option>
          </select>
          <span class="dash">-</span>
          <input class="phedit" size="4" :type="isACase ? 'password' : 'text'" v-model="phoneMid" :disabled="!fieldsEnabled" maxlength="4" />
          <span class="dash">-</span>
          <input class="phedit" size="4" :type="isACase ? 'password' : 'text'" v-model="phoneLast" :disabled="!fieldsEnabled" maxlength="4" />
        </div>
        <!-- 22001: 통신사 콤보(SKT/KT/LGT/알뜰 → 01~06). A case: * 처리. 보통 길이. -->
        <div class="fr">
          <label><i v-if="!isStaffAdmin" class="rp red"></i>통신사</label>
          <input v-if="isACase" type="password" :value="carrierLabel" disabled class="phcombo" />
          <select v-else class="phcombo" v-model="carrier" :disabled="!fieldsEnabled">
            <option value="">선택</option>
            <option v-for="c in carriers" :key="c.code" :value="c.code">{{ c.label }}</option>
          </select>
        </div>
        <!-- 20009: 월구독 자동신청일(오늘 이후, 보통 길이) / 월구독 결제수단. A case 는 마스킹(* 처리) -->
        <!-- 21001: 월구독 자동신청일/결제수단은 필수 항목에서 제외 → 적색 point 없음 -->
        <div class="fr">
          <label>월구독 자동신청일</label>
          <input class="autodt" :type="isACase ? 'password' : 'date'" :min="todayStr" v-model="autoOrderDt" :disabled="!fieldsEnabled" />
        </div>
        <div class="fr">
          <label>월구독 결제수단</label>
          <input v-if="isACase" type="password" :value="autoOrderPayType" disabled />
          <select v-else v-model="autoOrderPayType" :disabled="!fieldsEnabled">
            <option value="">선택하세요</option>
            <option value="신용카드">신용카드</option>
            <option value="체크카드">체크카드</option>
          </select>
        </div>
        <div class="fr">
          <label><i v-if="!isStaffAdmin" class="rp red"></i>추천인 아이디</label>
          <input :value="referrerLoginId" disabled />
          <button class="srch" :disabled="!fieldsEnabled" @click="memberTarget='referrer'; memberOpen=true">검색</button>
          <button class="clr" :disabled="!fieldsEnabled" @click="clearReferrer">비우기</button>
        </div>
        <div class="fr">
          <label><i v-if="!isStaffAdmin" class="rp red"></i>후원인 아이디</label>
          <input :value="sponsorLoginId" disabled />
          <button class="srch" :disabled="!fieldsEnabled" @click="memberTarget='sponsor'; memberOpen=true">검색</button>
          <button class="clr" :disabled="!fieldsEnabled" @click="clearSponsor">비우기</button>
        </div>
        <div class="fr">
          <label><i class="rp red"></i>센터</label>
          <input :value="centerName" disabled />
          <button class="srch" :disabled="!fieldsEnabled" @click="centerOpen=true">검색</button>
        </div>
      </div>

      <p v-if="message" :class="error ? 'error' : 'ok'">{{ message }}</p>
    </div>

    <SettlementMemberSearchDialog v-if="memberOpen" @select="onPickMember" @close="memberOpen=false" />
    <SettlementCenterSearchDialog v-if="centerOpen" @select="onPickCenter" @close="centerOpen=false" />
  </div>
</template>

<script>
import api from '../api';
import SettlementMemberSearchDialog from './SettlementMemberSearchDialog.vue';
import SettlementCenterSearchDialog from './SettlementCenterSearchDialog.vue';

export default {
  name: 'MyPageDialog',
  components: { SettlementMemberSearchDialog, SettlementCenterSearchDialog },
  props: { customerId: { type: [Number, String], required: true } },
  data() {
    return {
      loginId: '', name: '', enName: '', password: '', passwordConfirm: '', email: '',
      jumin1: '', jumin2: '', bankCode: '', bankCountry: '', account: '',
      autoOrderDt: '', autoOrderPayType: '',   // 20009: 월구독 자동신청일 / 결제수단
      // 22001: 휴대전화(콤보+에디트2) / 통신사(01~06)
      phonePrefix: '', phoneMid: '', phoneLast: '', carrier: '',
      phonePrefixes: ['010', '011', '016', '017', '018', '019'],
      carriers: [
        { code: '01', label: 'SKT' }, { code: '02', label: 'KT' }, { code: '03', label: 'LGT' },
        { code: '04', label: 'SKT (알뜰)' }, { code: '05', label: 'KT (알뜰)' }, { code: '06', label: 'LGT (알뜰)' }
      ],
      referrerLoginId: '', sponsorLoginId: '', centerId: null, centerName: '',
      caseType: 'A', regYn: 'N', banks: [],
      memberOpen: false, memberTarget: '', centerOpen: false,
      busy: false, message: '', error: false
    };
  },
  computed: {
    // 20008: 버튼 표시.
    //   · customer 본인(B): reg_yn N → 등록, reg_yn Y → 버튼 없음(수정은 관리자 문의)
    //   · staff/admin(C): db reg_yn 상관없이 무조건 수정 버튼 표시
    //   · A(자식 조회): 취소만
    showRegister() { return this.caseType === 'B' && this.regYn === 'N'; },
    showSave() { return this.caseType === 'C'; },
    // 20006: A case(customer 가 자기 아래 자식을 선택) - 민감정보 마스킹(type=password)
    isACase() { return this.caseType === 'A'; },
    // 22001: 통신사 코드(01~06) → 표시 라벨(A case 마스킹 표시용)
    carrierLabel() { const c = this.carriers.find(x => x.code === this.carrier); return c ? c.label : ''; },
    // 20008: 아이디 위 안내 문구(role 기반).
    //  · customer(caseType A/B): reg_yn N → 적색 "필수 입력" 안내, reg_yn Y → 청색 "수정 문의" 안내
    //  · staff/admin(caseType C): 적색 "센터 이외 필수 정보 미입력 가능" 안내
    isStaffAdmin() { return this.caseType === 'C'; },
    // 20009: 안내 문구는 staff/admin(C) 또는 customer 본인(B)일 때만 표시. A case(자식 조회)에서는 감춤.
    showNotice() { return this.caseType !== 'A'; },
    // 20009: 월구독 자동신청일 캘린더 최소값 = 오늘(오늘 이후 선택 가능)
    todayStr() {
      const d = new Date();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return d.getFullYear() + '-' + m + '-' + dd;
    },
    regNotice() {
      if (this.isStaffAdmin) return '※ 관리자는 이름, 센터 이외 필수 정보를 입력하지 않아도 됩니다';
      return this.regYn === 'Y'
        ? '※ 최초 등록 완료 이후 수정을 원하실 경우, 관리자에게 문의하시기 바랍니다.'
        : '※ 적색 점 항목은 필수 입력 정보입니다.';
    },
    // 문구 색상: 청색은 customer + reg_yn Y 뿐, 그 외(customer N / staff·admin)는 적색
    noticeClass() {
      return (!this.isStaffAdmin && this.regYn === 'Y') ? 'blue' : 'red';
    },
    // 이름/아이디 제외 활성화 조건: C 는 항상, B 는 reg_yn=N 일 때
    fieldsEnabled() {
      if (this.caseType === 'C') return true;
      if (this.caseType === 'B') return this.regYn === 'N';
      return false;   // A
    }
  },
  async created() {
    await this.loadBanks();
    await this.reload();
  },
  methods: {
    async loadBanks() {
      try { const r = await api.myPageBanks(); this.banks = r.data || []; } catch (e) { this.banks = []; }
    },
    async reload() {
      this.message = ''; this.error = false;
      try {
        const r = await api.myPageInfo(this.customerId);
        const d = r.data || {};
        this.loginId = d.loginId || ''; this.name = d.name || '';
        this.enName = d.enName || ''; this.email = d.email || '';
        this.bankCode = d.bankCode || ''; this.bankCountry = d.bankCountry || '';
        this.account = d.account || '';
        this.autoOrderDt = d.autoOrderDt || ''; this.autoOrderPayType = d.autoOrderPayType || '';
        this.phonePrefix = d.phonePrefix || ''; this.phoneMid = d.phoneMid || ''; this.phoneLast = d.phoneLast || '';
        this.carrier = d.carrier || '';
        const j = d.jumin || '';
        this.jumin1 = j.length > 6 ? j.substring(0, 6) : j;
        this.jumin2 = j.length > 6 ? j.substring(6) : '';
        this.referrerLoginId = d.referrerLoginId || '';
        this.sponsorLoginId = d.sponsorLoginId || '';
        this.centerId = d.centerId || null; this.centerName = d.centerName || '';
        this.caseType = d.caseType || 'A'; this.regYn = d.regYn || 'N';
        this.password = ''; this.passwordConfirm = '';
      } catch (e) { this.error = true; this.message = e.message; }
    },
    onPickMember(m) {
      // 검색 전/후 동일 회원이면 에러
      const cur = this.memberTarget === 'referrer' ? this.referrerLoginId : this.sponsorLoginId;
      if (m.loginId === cur) { this.error = true; this.message = '동일한 회원입니다.'; this.memberOpen = false; return; }
      if (this.memberTarget === 'referrer') this.referrerLoginId = m.loginId;
      else this.sponsorLoginId = m.loginId;
      this.memberOpen = false; this.error = false; this.message = '';
    },
    onPickCenter(c) {
      if (c.centerName === this.centerName) { this.error = true; this.message = '동일한 센터입니다.'; this.centerOpen = false; return; }
      this.centerId = c.id; this.centerName = c.centerName; this.centerOpen = false; this.error = false; this.message = '';
    },
    clearReferrer() { this.referrerLoginId = ''; },
    clearSponsor() { this.sponsorLoginId = ''; },
    payload() {
      return {
        customerId: this.customerId, name: this.name, enName: this.enName, email: this.email,
        password: this.password, passwordConfirm: this.passwordConfirm,
        jumin1: this.jumin1, jumin2: this.jumin2,
        bankCode: this.bankCode, bankCountry: bankCountryOf(this.banks, this.bankCode, this.bankCountry),
        account: this.account,
        autoOrderDt: this.autoOrderDt, autoOrderPayType: this.autoOrderPayType,
        phonePrefix: this.phonePrefix, phoneMid: this.phoneMid, phoneLast: this.phoneLast, carrier: this.carrier,
        referrerLoginId: this.referrerLoginId, sponsorLoginId: this.sponsorLoginId,
        centerId: this.centerId
      };
    },
    async doRegister() {
      if (!window.confirm('등록하시겠습니까?')) return;
      await this.submit(true);
    },
    async doSave() {
      if (!window.confirm('수정하시겠습니까?')) return;
      await this.submit(false);
    },
    async submit(register) {
      this.busy = true; this.message = ''; this.error = false;
      try {
        const res = register ? await api.myPageRegister(this.payload()) : await api.myPageSave(this.payload());
        const data = res.data || {};
        if (data.success === false) { this.error = true; this.message = res.message || '처리할 수 없습니다.'; return; }
        this.$emit('saved');
      } catch (e) { this.error = true; this.message = e.message; }
      finally { this.busy = false; }
    },
    close() { this.$emit('close'); }
  }
};

function bankCountryOf(banks, code, fallback) {
  const b = (banks || []).find(x => x.code === code);
  return b ? b.country : fallback;
}
</script>

<style scoped>
.modal-mask { position: fixed; inset: 0; background: rgba(0,0,0,.45); display: flex; align-items: center; justify-content: center; z-index: 78; }
/* 20009: 팝업 가로 = 기존 560px + 라벨 확대분 40px(=600px). 늘어난 폭은 라벨 컬럼에만 배분(입력창 폭 유지) */
.modal { background: #fff; padding: 20px 22px; border-radius: 8px; width: 600px; max-width: 96vw; max-height: 92vh; overflow: auto; }
.head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
.head h4 { margin: 0; }
.head-btns button { padding: 7px 14px; border-radius: 6px; cursor: pointer; border: 1px solid #ccc; margin-left: 6px; }
.head-btns .primary { background: #2f6fed; color: #fff; border-color: #2f6fed; }
.head-btns .primary:disabled { background: #9db8ef; border-color: #9db8ef; cursor: default; }
.head-btns .ghost { background: #f5f5f5; }
/* 20008: 아이디 위 안내 문구(색상 적/청) */
.reg-notice { margin: 0 0 12px; font-size: 12.5px; }
.reg-notice.red { color: #d93636; }
.reg-notice.blue { color: #2f6fed; }
.form { display: flex; flex-direction: column; gap: 9px; }
.fr { display: flex; align-items: center; gap: 8px; }
.fr label { width: 140px; font-size: 13px; color: #555; flex: 0 0 140px; display: inline-flex; align-items: center; }
/* 20007: 필수 설정 항목 표시 point (적색), 비밀번호류는 청색 */
.fr label .rp { width: 6px; height: 6px; border-radius: 50%; display: inline-block; margin-right: 8px; flex: 0 0 auto; }
.fr label .rp.red { background: #e01010; }
.fr label .rp.blue { background: #2f6fed; }
.fr input, .fr select { flex: 1; padding: 7px 9px; border: 1px solid #d0d5dd; border-radius: 6px; }
.fr input:disabled, .fr select:disabled { background: #f2f4f7; color: #667085; }
.fr input.jumin { flex: 0 0 110px; }
/* 20009: 월구독 자동신청일은 팝업 가로에 맞추지 않고 보통 길이 */
.fr input.autodt { flex: 0 0 180px; }
/* 22001: 휴대전화 앞자리 콤보/통신사 콤보는 보통 길이, 휴대전화 에디트 2개는 짧게 */
/* 22001(개정): 에디트 2개 가로 축소 - 팝업 가로 폭을 넘지 않도록.
   min-width:0 으로 input 기본 intrinsic 폭(flex min-width:auto)이 basis 를 밀어내지 않게 고정. */
.fr .phcombo { flex: 0 0 110px; min-width: 0; }
.fr input.phedit { flex: 0 0 58px; min-width: 0; }
.fr .dash { color: #888; }
.srch { flex: 0 0 auto; padding: 6px 11px; border: 1px solid #2f6fed; background: #eef4ff; color: #2f5fd0; border-radius: 6px; cursor: pointer; font-size: 12px; }
.clr { flex: 0 0 auto; padding: 6px 11px; border: 1px solid #c0c6d0; background: #f2f4f7; color: #444; border-radius: 6px; cursor: pointer; font-size: 12px; }
.srch:disabled, .clr:disabled { opacity: .5; cursor: default; }
.error { color: #d93636; font-size: 13px; margin: 10px 0 0; }
.ok { color: #1a7f37; font-size: 13px; margin: 10px 0 0; }
</style>
